app.directive('downloadUserReport', ['progressBarService', 'userManagementService', 'storagemanagementService', function (progressBarService, userManagementService, storagemanagementService) {
    return {
        restrict: 'E',
        templateUrl: '../app/modules/templates/downloadUserReport.html',
        link: function ($scope, element, attr) {
            $scope.downloadReport = function ()
            {
                if ($scope.abbreviatedReport && $scope.isUserManagementPage) {
                    $scope.exportUserManagementReportData();
                } else if ($scope.abbreviatedReport && !$scope.isUserManagementPage) {
                    $scope.exportUserAnalyticsReportData();
                } else if ($scope.fullReport) {
                    $scope.exportFullReportData();
                }
            }

            $scope.getCurrentDate = function ()
            {
                var today, dd, mm, yyyy, currentDate, startDate, endDate, parameter;
                today = new Date();
                dd = today.getDate();
                mm = today.getMonth() + 1; //January is 0!

                yyyy = today.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                $scope.currentDate = mm + '/' + dd + '/' + yyyy;
            }

            $scope.exportUserManagementReportData = function ()
            {
                progressBarService.showProgressBar();
                $scope.getCurrentDate();
                var data = {
                    SortBy: $scope.pagination.sortBy,
                    Reverse: $scope.pagination.reverse ? 'desc' : 'asc',
                    eSpectraFullName: $scope.models.name,
                    eSpectraEmail: $scope.models.email,
                    eSpectraPrimaryAffiliationName: $scope.models.affiliation,
                    PremiumType: $scope.models.premium ? '1' : '0',
                    Restricted: $scope.models.restricted ? '1' : '0',
                    Free: $scope.models.free ? '1' : '0',
                    Active: $scope.models.active ? 'active' : '0',
                    Deactivated: $scope.models.deactivated ? 'deactivated' : '0',
                    Suspended: $scope.models.suspended ? 'suspended' : '0',
                    Unactivated: $scope.models.Unactivated ? 'pending' : '0',
                    Administrator: $scope.models.admininstrator ? '1' : '0',
                    Deprecated: $scope.models.Deprecated ? 'deprecated' : '0',
                    IndividualAccount: $scope.models.individualAccount ? '1' : '0',
                    InstitutionAccount: $scope.models.institutionAccount ? '1' : '0'
                }

                userManagementService.getDataReport(data).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        //$timeout(hideMessage, 10000);
                    }
                    else {
                        var csv = convertArrayOfObjectsToCSV({
                            data: response.data,
                            reportType: "userManagementReport"
                        });

                        BlobDownloadCSV('UserManagementReport_' + $scope.currentDate + '.csv', csv)
                        if ($scope.fullReport) {
                            $scope.exportFullReportData();
                        } else {
                            $('#downloadReportDialog').modal('hide');
                        }
                    }

                    progressBarService.hideProgressBar();
                });
            }

            $scope.exportUserAnalyticsReportData = function ()
            {
                progressBarService.showProgressBar();
                $scope.getCurrentDate();
                storagemanagementService.getStorageDetailsReport($scope.searchByUser).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        //$timeout(hideMessage, 10000);
                    }
                    else {
                        var csv = convertArrayOfObjectsToCSV({
                            data: response.data.dataManagementDetailsExport,
                            reportType: "userAnanyticsReport"
                        });

                        BlobDownloadCSV('UserAnalyticsReport_' + $scope.currentDate + '.csv', csv)
                        if ($scope.fullReport) {
                            $scope.exportFullReportData();
                        } else {
                            $('#downloadReportDialog').modal('hide');
                        }
                    }

                    progressBarService.hideProgressBar();
                });
            }

            $scope.exportFullReportData = function ()
            {
                progressBarService.showProgressBar();
                $scope.getCurrentDate();
                if ($scope.isUserManagementPage) {
                    var data = {
                        SortBy: $scope.pagination.sortBy,
                        Reverse: $scope.pagination.reverse ? 'desc' : 'asc',
                        eSpectraFullName: $scope.models.name,
                        eSpectraEmail: $scope.models.email,
                        eSpectraPrimaryAffiliationName: $scope.models.affiliation,
                        PremiumType: $scope.models.premium ? '1' : '0',
                        Restricted: $scope.models.restricted ? '1' : '0',
                        Free: $scope.models.free ? '1' : '0',
                        Active: $scope.models.active ? 'active' : '0',
                        Suspended: $scope.models.suspended ? 'suspended' : '0',
                        Unactivated: $scope.models.Unactivated ? 'pending' : '0',
                        Administrator: $scope.models.admininstrator ? '1' : '0',
                        Deactivated: $scope.models.deactivated ? 'deactivated' : '0',
                        Deprecated: $scope.models.Deprecated ? 'deprecated' : '0',
                        IndividualAccount: $scope.models.individualAccount ? '1' : '0',
                        InstitutionAccount: $scope.models.institutionAccount ? '1' : '0'
                    }
                } else {
                    var data = {
                        SortBy: $scope.searchByUser.sortBy == "" ? 'eSpectraFirstName' : $scope.searchByUser.sortBy,
                        Reverse: $scope.searchByUser.reverse ? 'desc' : 'asc',
                        eSpectraFullName: $scope.searchByUser.searchByName,
                        eSpectraEmail: $scope.searchByUser.searchByEmail,
                        eSpectraPrimaryAffiliationName: $scope.searchByUser.searchByInstitutionName,
                        PremiumType: $scope.searchByUser.searchByPremium ? '1' : '0',
                        Restricted: $scope.searchByUser.searchByRestricted ? '1' : '0',
                        Free: $scope.searchByUser.searchByFree ? '1' : '0',
                        Active: 'active',
                        Suspended: 'suspended',
                        Unactivated: 'pending',
                        Administrator: $scope.searchByUser.searchByAdministrator ? '1' : '0',
                        Deprecated: '0',
                        Deactivated: 'deactivated',
                        IndividualAccount: $scope.searchByUser.searchByIndividualAccount ? '1' : '0',
                        InstitutionAccount: $scope.searchByUser.searchByInstitutionAccount ? '1' : '0'
                    }
                }

                userManagementService.getFullDataReport(data).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        //$timeout(hideMessage, 10000);
                    }
                    else {
                        var csv = convertArrayOfObjectsToCSV({
                            data: response.data,
                            reportType: "fullReport"
                        });

                        BlobDownloadCSV('UserManagementFullReport_' + $scope.currentDate + '.csv', csv)

                    }
                    $('#downloadReportDialog').modal('hide');
                    progressBarService.hideProgressBar();
                });
            }

            function convertArrayOfObjectsToCSV(args) {

                var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

                data = args.data || null;
                if (data == null || !data.length) {
                    return null;
                }

                columnDelimiter = args.columnDelimiter || ',';
                lineDelimiter = args.lineDelimiter || '\n';


                keys = Object.keys(data[0]).slice(1);

                if (args.reportType == "fullReport") {
                    headers = [" ", " ", " ", " ", " ", " ", " ", " ", "User", " ", " ", " ", " ", " ", " ", "Storage", " ", " ", " ", "Personal Details"]
                    result = 'System User / Usage Activity Report' + lineDelimiter;
                    result += headers.join(columnDelimiter);
                    result += lineDelimiter;
                    headers = ["Sr. No",
                       "Product Description",
                       "Total Number of Seats",
                       "Amount of Seats Utilized",
                       "Remaining Number of Seats in Account",
                       "User Type",
                       "User Status",
                       //"Admin Status",
                    "Name",
                    "Email Address",
                    "Role Type",
                    "Create Date",
                    "Start Date",
                    "End Date",
                    "Last Login Date/Time",
                    "Capacity Available",
                    "Capacity Used",
                    "% Usage",
                    "No of Files",
                    "Institutional Affiliation",
                    "Current Title",
                    "Research Interests",
                    "Count of Invitations Sent",
                    "Email Addresses of Invitees",
                    "Count of Invitees that Registered",
                    "Email Addresses of Registered Invitees"]
                } else if (args.reportType == "userManagementReport") {
                    headers = ["Sr No.",
                        "Name",
                        "Email Address",
                        "Affiliation Name",
                        //"Admin Status",
                        "User Status",
                        "Admin Note",
                        "User Type",
                        "Role Type"]

                    result = 'Report Name' + columnDelimiter + "User Management Report" + lineDelimiter;
                } else {
                    headers = ["Sr No.",
                        "Email Address",
                        "Name",
                        "Affiliation",
                        "Capacity Available",
                        "Capacity Used",
                        "No. Of Files",
                        "User Type",
                        "Role Type",
                        "Create Date",
                        "Start Date",
                        "End Date"]

                    result = 'Report Name' + columnDelimiter + "User Unalytics Report" + lineDelimiter;
                }

                result += headers.join(columnDelimiter);
                result += lineDelimiter;

                data.forEach(function (item) {

                    ctr = 0;
                    keys.forEach(function (key) {
                        if (ctr > 0) result += columnDelimiter;

                        result += item[key];
                        ctr++;
                    });
                    result += lineDelimiter;
                });

                return result;
            }
        }
    }
}]);

